import HeaderMaintainer from '@/shared/components/headers/HeaderMaintainer';
import LoaderPage from '@/shared/components/loaders/LoaderPage';
import NavBar from '@/shared/components/navbar/NavBar';
import { Outlet, useNavigation } from 'react-router-dom';

/**
 * Layout principal para todas las rutas privadas del sistema.
 *
 * Funcionalidad:
 * - Proporciona la estructura base para el dashboard, estudiantes, y todas las vistas privadas
 * - Incluye navegación persistente (navbar) y header de mantenedor
 * - Maneja estados de carga durante transiciones de navegación con loader de página completa
 * - Renderiza contenido dinámico mediante React Router Outlet
 *
 * Responsabilidades:
 * - Renderizar la navbar de navegación principal
 * - Mostrar el HeaderMaintainer con información contextual
 * - Gestionar el Outlet para renderizado de rutas hijas
 * - Detectar y mostrar LoaderPage durante navegación entre rutas
 * - Mantener estructura responsive con overflow adecuado
 */
const PrivateLayout = () => {
  const navigation = useNavigation();
  const isNavigating = navigation.state === 'loading';

  return (
    <div className="relative flex flex-col gap-2 h-screen p-1">
      <NavBar />

      <main className="flex flex-col gap-1 rounded-xl min-h-0 flex-1 overflow-auto">
        <HeaderMaintainer />
        <div className="md:flex-1 min-h-0 overflow-auto">
          <Outlet />
        </div>
      </main>

      {isNavigating && <LoaderPage />}
    </div>
  );
};

export default PrivateLayout;
